export default __webpack_public_path__ + "static/media/photo--lg--7.6a6a1d3d.jpg";